// The list API returns an integrator's type either as the code ("AREA_BASED") or as the display
// name ("Area Based"), depending on the path that built the row; filters and labels work on the code.
export const integratorTypeCode = (value) => {
  const raw = String(value || '').trim();
  return raw.includes(' ') ? raw.toUpperCase().replace(/\s+/g, '_') : raw.toUpperCase();
};

export const integratorTypeLabel = (value) =>
  integratorTypeCode(value)
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ') || '-';
